














































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import CommonMixin, {
WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START,
} from "@/mixins/common-mixins";
import { AppData, CareGiver } from "@/models/app-data";
import { WorkflowService } from "@/service/workflow.service";
import PageLoader from "@/components/PageLoader.vue"
import { MatchHeadstartAndHSGSRPLikelyReferralContent } from "@/models/content/match-headstart-and-hs-gsrp-likely-referral";

@Component({
  components: {
    FooterButton,
    PageLoader
  },
})
export default class MatchHeadstartAndHSGSRPLikelyReferral extends Mixins(CommonMixin) {
  workflowService = new WorkflowService();
  appData = {} as AppData;
  loadDataFinished = false;
  content: MatchHeadstartAndHSGSRPLikelyReferralContent = {} as MatchHeadstartAndHSGSRPLikelyReferralContent;
  textDirection = 'ltr'

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchHeadStartAndHSGSRPLikelyReferralContent();
      this.textDirection = contentService.TextDirection()
      await this.loadData();

    } catch (error) {
        this.showError(error as any);
    }
  }


  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      this.appData = await this.workflowToAppData(workflowId);
      await this.putWorkflowStep( this.appData.workflowId, "MatchHeadstartAndHSGSRPLikelyReferral") 
      this.saveAppData(this.appData);
    } else {
      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START;
        this.saveAppData(this.appData);

        await this.putWorkflowStep( this.appData.workflowId, "MatchHeadstartAndHSGSRPLikelyReferral") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );
      }
    }
    this.loadDataFinished = true;
  }

  disableNext(): boolean {
    return !this.loadDataFinished;
  }

    public async handleLearnMore(): Promise<void> {
    window.open( this.content.LearnMoreUrl, "_blank"); 
    await this.publishWebLearnMoreClickEvent( this.appData.workflowId) 
  }
}
